import './home.css'
import React, {useEffect, useState} from "react";
import {useHistory} from 'react-router-dom'
import {connect} from "react-redux";
import {active} from "../../reducer/functionreducer";
import users, {changeerror, rememberMe, saveusers} from "../../reducer/users";
import axios from "axios";
import {BaseUrl} from "../../middleware";
import {useTranslation} from "react-i18next";

function Home({saveusers, users, changeerror,rememberMe}) {
    const [inputlogin, setLogin] = useState('')
    const [inputparol, setparol] = useState('')
    const [typeinput, Settype] = useState('password')
    const history = useHistory()
    const {t} = useTranslation();
    function login(event) {
        setLogin(event.target.value)
        changeerror()
    }

    function parol(event) {
        setparol(event.target.value)
        changeerror()
    }

    function changechecked(e) {
        rememberMe({
            checked:e.target.checked
        })
    }

    function changetypeinput() {
        if (typeinput === 'text') {
            Settype('password')
        } else {
            Settype('text')
        }
    }

    function onSubmit(e) {
        e.preventDefault();
        axios({
            method: 'post',
            url: `${BaseUrl}/auth/login`,
            data: {
                username: inputlogin,
                password: inputparol
            }
        }).then(function (res) {
            saveusers(res.data)
            window.location.reload();
        }).catch(function (err) {
            saveusers({...err})
        })
    }

    useEffect(() => {
        let user = JSON.parse(localStorage.getItem('user') || sessionStorage.getItem('user'))
        let tokenname = localStorage.getItem('tokenname') || sessionStorage.getItem('tokenname')

        if (user && tokenname){
            saveusers({
                object:user,
                message: tokenname,
                success: true
            })
            history.push(users.viewDashboardChecked ? '/headerthird' : '/headerthird/profil')
        }
    }, [])

    return (
        <div>
            <div id={'home'}>
                <div className={'home-body'} style={{display:"contents"}}>
                    <div className="card"  style={{background:"rgba(102,102,102,0)", boxShadow:"none", border:"none"}}>

                        <div className="home-enter" style={{marginLeft:"auto", marginRight:"auto", background:"#1B3F92", padding:"inherit", borderRadius:"10px"}}>
                            <div className="kirish-text">
                                <h5 style={{color:"#fff"}}>{t('Welcome.3')}</h5>
                                <p style={{color:"#fff"}} className={'p'}>
                                    {t('Welcome.4')}
                                </p>
                            </div>
                            <form onSubmit={onSubmit}>
                                <div className={`kirish-input`}>
                                    <input onChange={login} id="login" value={inputlogin} type="text" className={'form-control login'}
                                           placeholder="login"/>
                                    <div className={'input'}>
                                        <input onChange={parol} id="password" value={inputparol} type={typeinput}
                                               className={'form-control pasword'}
                                               placeholder="password"/>
                                        {typeinput === "password"?
                                            <i onClick={changetypeinput} class="fa-solid fa-eye-slash"></i>:
                                            <i onClick={changetypeinput} class="fa-solid fa-eye"></i>}
                                    </div>
                                    {
                                        users.error ? <span className={'error'}>{t('Welcome.5')} !</span> : ''
                                    }
                                    <div className="kirish-checkbox">
                                        <input onChange={changechecked} checked={users.rememberme} type="checkbox" id={'check'}/>
                                        <label htmlFor={'check'}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <title>ionicons-v5-l</title>
                                                <path
                                                    d="M400,48H112a64.07,64.07,0,0,0-64,64V400a64.07,64.07,0,0,0,64,64H400a64.07,64.07,0,0,0,64-64V112A64.07,64.07,0,0,0,400,48ZM364.25,186.29l-134.4,160a16,16,0,0,1-12,5.71h-.27a16,16,0,0,1-11.89-5.3l-57.6-64a16,16,0,1,1,23.78-21.4l45.29,50.32L339.75,165.71a16,16,0,0,1,24.5,20.58Z"/>
                                            </svg>
                                        </label>
                                        <div className="login">
                                            <label style={{cursor: 'pointer', color: '#fff'}} htmlFor={'check'}>{t('tes.1')}</label>
                                            {/*<a href="">{t('Welcome.6')}</a>*/}
                                        </div>
                                    </div>
                                    <button style={{background:"#386be1"}} type="submit"
                                            className={' form-control kirish'}>{t('Welcome.7')}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default connect((users), {saveusers, active, changeerror,rememberMe})(Home)
